// extracted by mini-css-extract-plugin
module.exports = {"page":"ResetPage_page__3UXw0","nav":"ResetPage_nav__16jUh","resetButton":"ResetPage_resetButton__3JLeA","resetText":"ResetPage_resetText__7nuPq"};